import { packingSlipSchema } from "@redotech/redo-fulfillment-operations-common/packing-slips/packing-slip-definition";

export const updatePackingSlipTemplate = {
  name: "updatePackingSlipTemplate" as const,
  input: packingSlipSchema,
  output: packingSlipSchema,
};
